// apps/catalyst/app/app/constants/regions.ts
// Centralized regional store data for Catalyst locations menu

export interface StoreLocation {
  name: string;
  link: string;
  storeValue: string; // Added for mapping
}

export interface RegionData {
  name: string;
  displayName: string;
  stores: StoreLocation[];
}

/**
 * Updated regional organization based on team's final structure
 * 6 regions: Long Beach, Los Angeles, Orange County, Inland Empire/San Diego, Central Coast, Northern California
 */
export const STORE_REGIONS: Record<string, RegionData> = {
  'long-beach': {
    name: 'long-beach',
    displayName: 'Long Beach',
    stores: [
      {
        name: 'Belmont Shore',
        link: '/dispensary-locations/belmont-shore-dispensary',
        storeValue: 'catalystbelmont',
      },
      {
        name: 'Cherry Ave',
        link: '/dispensary-locations/cherry-ave-long-beach-dispensary',
        storeValue: 'catalyst405',
      },
      {
        name: 'Downtown',
        link: '/dispensary-locations/downtown-long-beach-dispensary',
        storeValue: 'catalystpine',
      },
      {
        name: 'Retro Row',
        link: '/dispensary-locations/retro-row-long-beach-dispensary',
        storeValue: 'catalystlift',
      },
      {
        name: 'swed',
        link: '/dispensary-locations/swed-long-beach-dispensary',
        storeValue: 'catalyst10th',
      },
    ],
  },
  'los-angeles': {
    name: 'los-angeles',
    displayName: 'Los Angeles',
    stores: [
      {
        name: 'Bellflower',
        link: '/dispensary-locations/bellflower-dispensary',
        storeValue: 'catalystbellflower',
      },
      {
        name: 'El Monte',
        link: '/dispensary-locations/el-monte-dispensary',
        storeValue: 'catalystelmonte',
      },
      {
        name: 'Figueroa Ave',
        link: '/dispensary-locations/figueroa-los-angeles-dispensary',
        storeValue: 'catalystfigueroa',
      },
      {
        name: 'Florence Ave',
        link: '/dispensary-locations/florence-los-angeles-dispensary',
        storeValue: 'catalystflorence',
      },
      {
        name: 'Hawthorne - Dispensary',
        link: '/dispensary-locations/hawthorne-dispensary',
        storeValue: 'catalysthawthorne',
      },
      {
        name: 'Hawthorne - Cannabis Lounge',
        link: '/dispensary-locations/hawthorne-cannabis-lounge',
        storeValue: 'catalysthawthorne2',
      },
      {
        name: 'Lancaster',
        link: '/dispensary-locations/lancaster-dispensary',
        storeValue: 'catalystlancaster',
      },
      {
        name: 'Lynwood',
        link: '/dispensary-locations/lynwood-dispensary',
        storeValue: 'catalystlynwood',
      },
      {
        name: 'Mid City',
        link: '/dispensary-locations/mid-city-los-angeles-dispensary',
        storeValue: 'catalystmidcity',
      },
      {
        name: 'Normandie Ave',
        link: '/dispensary-locations/normandie-los-angeles-dispensary',
        storeValue: 'catalystnormandie',
      },
      {
        name: 'Pomona',
        link: '/dispensary-locations/pomona-dispensary',
        storeValue: 'catalystpomona',
      },
      {
        name: 'Silver Lake',
        link: '/dispensary-locations/silver-lake-dispensary',
        storeValue: 'catalystsilverlake',
      },
      {
        name: 'Van Nuys',
        link: '/dispensary-locations/van-nuys-dispensary',
        storeValue: 'catalystvannuys',
      },
    ],
  },
  'orange-county': {
    name: 'orange-county',
    displayName: 'Orange County',
    stores: [
      {
        name: 'Costa Mesa',
        link: '/dispensary-locations/costa-mesa-dispensary',
        storeValue: 'catalystcostamesa',
      },
      {
        name: 'Santa Ana',
        link: '/dispensary-locations/santa-ana-dispensary',
        storeValue: 'catalystsantaana',
      },
      {
        name: 'Santa Ana - OC3',
        link: '/dispensary-locations/oc3-santa-ana-dispensary',
        storeValue: 'oc3',
      },
      {
        name: 'Planet Catalyst',
        link: '/dispensary-locations/planet-catalyst-orange-county',
        storeValue: 'catalystp13',
      },
      {
        name: 'Stanton',
        link: '/dispensary-locations/stanton-dispensary',
        storeValue: 'catalyststanton',
      },
    ],
  },
  'inland-empire-san-diego': {
    name: 'inland-empire-san-diego',
    displayName: 'Inland Empire / San Diego',
    stores: [
      {
        name: 'Hemet',
        link: '/dispensary-locations/hemet-dispensary',
        storeValue: 'catalysthemet',
      },
      {
        name: 'Moreno Valley',
        link: '/dispensary-locations/moreno-valley-dispensary',
        storeValue: 'catalystmorenovalley',
      },
      {
        name: 'Palm Desert',
        link: '/dispensary-locations/palm-desert-dispensary',
        storeValue: 'catalystpalmdesert',
      },
      {
        name: 'San Bernardino',
        link: '/dispensary-locations/san-bernardino-dispensary',
        storeValue: 'catalystsbinland',
      },
      {
        name: 'San Diego',
        link: '/dispensary-locations/san-diego-dispensary',
        storeValue: 'catalystsandiego',
      },
    ],
  },
  'central-coast': {
    name: 'central-coast',
    displayName: 'Central Coast',
    stores: [
      {
        name: 'Grover Beach',
        link: '/dispensary-locations/grover-beach-dispensary',
        storeValue: 'catalystgroverbeach',
      },
      {
        name: 'Marina',
        link: '/dispensary-locations/marina-dispensary',
        storeValue: 'catalystmarina',
      },
      {
        name: 'Oxnard',
        link: '/dispensary-locations/oxnard-dispensary',
        storeValue: 'catalystoxnard',
      },
      {
        name: 'Watsonville',
        link: '/dispensary-locations/watsonville-dispensary',
        storeValue: 'catalystwatsonville',
      },
    ],
  },
  'northern-california': {
    name: 'northern-california',
    displayName: 'Northern California',
    stores: [
      {
        name: 'Antioch',
        link: '/dispensary-locations/antioch-dispensary',
        storeValue: 'catalystantioch',
      },
      {
        name: 'Daly City',
        link: '/dispensary-locations/daly-city-dispensary',
        storeValue: 'catalystdalycity',
      },
      {
        name: 'Patterson',
        link: '/dispensary-locations/patterson-dispensary',
        storeValue: 'catalystpatterson',
      },
    ],
  },
};

// Utility functions for easy integration
export const getRegionByStoreValue = (storeValue: string): string | null => {
  for (const [regionKey, regionData] of Object.entries(STORE_REGIONS)) {
    const store = regionData.stores.find((store) => store.storeValue === storeValue);
    if (store) return regionKey;
  }
  return null;
};

export const getRegionDisplayName = (regionKey: string): string => {
  return STORE_REGIONS[regionKey]?.displayName || regionKey;
};

export const getAllRegions = (): RegionData[] => {
  return Object.values(STORE_REGIONS);
};

export const getStoresByRegion = (regionKey: string): StoreLocation[] => {
  return STORE_REGIONS[regionKey]?.stores || [];
};

// For backwards compatibility - convert to old format
export const getRegionsAsLegacyFormat = (): Record<
  string,
  Array<{ name: string; link: string }>
> => {
  const legacy: Record<string, Array<{ name: string; link: string }>> = {};

  Object.entries(STORE_REGIONS).forEach(([key, region]) => {
    legacy[region.displayName] = region.stores.map((store) => ({
      name: store.name,
      link: store.link,
    }));
  });

  return legacy;
};

// Pre-computed mapping for performance
export const STORE_TO_REGION_MAP: Record<string, string> = {};
Object.entries(STORE_REGIONS).forEach(([regionKey, regionData]) => {
  regionData.stores.forEach((store) => {
    if (store.storeValue) {
      STORE_TO_REGION_MAP[store.storeValue] = regionKey;
    }
  });
});
